import { FC } from 'react';

import { useContributionModal } from '../context/ContributionModalContext';
import { ContributionData } from '../types/ContributionData';

import ContributionTableRow from './ContributionTableRow';

const ContributionTableBody: FC = () => {
  const { data } = useContributionModal();

  return (
    <tbody>
      {data.contributions?.map(
        (contribution: ContributionData, index: number) => (
          <tr
            className="nk-tb-item"
            // eslint-disable-next-line react/no-array-index-key
            key={`contribution-row-${index}`}
          >
            <ContributionTableRow index={index} contribution={contribution} />
          </tr>
        )
      )}
    </tbody>
  );
};

export default ContributionTableBody;
